// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin,
  postMethod,
  multipartJsonHeader
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import AddTeam from '../addTeam';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';
import AddMember from '../addTournamentTeamMember';
import Dialog from 'material-ui/Dialog';
import Chip from 'material-ui/Chip';
import { colors, btn, card, form } from '../../../../style/common/partnerStyle';

function Toast({ message, type, onClose }) {
  if (!message) return null;
  const bg     = type === 'error' ? colors.dangerLt  : colors.successLt;
  const color  = type === 'error' ? colors.danger     : colors.success;
  const border = type === 'error' ? '#fca5a5'          : '#6ee7b7';
  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      padding: '12px 16px', borderRadius: 8, marginBottom: 16,
      background: bg, border: `1px solid ${border}`, fontSize: 13,
    }}>
      <span style={{ color, fontWeight: 600 }}>{message}</span>
      <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color, fontSize: 16, lineHeight: 1, padding: '0 0 0 12px' }}>✕</button>
    </div>
  );
}

class EditTournamentTeam extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      id: props.match.params.id,
      teams: [],
      groups: [],
      game_types: [],
      team_details: {
        team: {
          id: '',
          name: '',
          venue: '',
          batch: '',
        },
        amount_paid: '',
        new_logo: {},
        group: [],
      },
      age_groups: [],
      addMemberView: false,
      data_uploaded: false,
      data_error: false,
      team_members: [],
      to_delete_member_list: [],
      showFullTeamDetails_list: [],
      new_logo: '',
      logo_preview: '',
      venues: [],
      cities: [],
      batch_team: false,
      batches: [],
      selected_venue: '',
      filtered_venues: [],
      toast: null,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.getTeamList = this.getTeamList.bind(this);
    this.editTeamView = this.editTeamView.bind(this);
    this.handleBatchTeamCraetion = this.handleBatchTeamCraetion.bind(this);
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.state.onClickVenue = this.onClickVenue.bind(this);
  }

  componentDidMount() {
    this.getaddTeamInputs();
    this.getTeamList();
    this.getTeamDetailInput();
    console.log(this.state);
  }

  showToast(message, type = 'error') {
    this.setState({ toast: { message, type } });
  }

  getTeamDetailInput() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_tournament_team/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ groups: data.groups, age_groups: data.age_groups }); })
      .catch(error => error);
  }

  getaddTeamInputs() {
    const url = `${getLocationOrigin()}/eagleeye/get_inputs_for_add_team/`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ game_types: data.game_types }); })
      .catch(error => error);
  }

  postSaveTournamentTeam() {
    console.log('this.state.team_details');
    console.log(this.state.team_details);
    var formData = new FormData();
    formData.append('team_details', JSON.stringify(this.state.team_details));
    formData.append('new_logo', this.state.new_logo);
    formData.append('to_delete_member_list', JSON.stringify(this.state.to_delete_member_list));
    const url = `${getLocationOrigin()}/eagleeye/save_tournament_team_details/`;
    var options = {...defaultOptions, ...postMethod, ...multipartJsonHeader};
    options['body'] = formData;
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.props.history.goBack(); })
      .catch(error => {
        console.log(error);
        this.showToast(error && error.message ? error.message : 'Failed to save team');
      });
  }

  getTeamList() {
    const url = `${getLocationOrigin()}/eagleeye/get_competition_team?id=${this.state.id}`;
    const options = {...defaultOptions};
    fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        if(data.teamlist.team.batch) {
          this.setState({ batch_team: true, team_details: data.teamlist });
          this.getVenues();
        }
        else { this.setState({ team_details: data.teamlist }); }
      })
      .catch(error => {
        console.log(error);
        this.showToast(error && error.message ? error.message : 'Failed to load team');
      });
  }

  handleChange(event, team_id) {
    const name = event.target.name;
    let value = event.target.value;
    var new_selected_one = Object.assign({}, this.state.team_details);
    if(name == 'name') {
      new_selected_one.team.name = value;
      this.setState({ team_details: new_selected_one });
    }
    if(name == 'age_groups') {
      value = this.state.age_groups.filter(info => info.id == value)[0];
      new_selected_one.age_groups = value;
      this.setState({ team_details: new_selected_one });
    }
    if(name == 'batch') {
      new_selected_one.team.batch = value;
      this.setState({ team_details: new_selected_one });
    }
    else {
      new_selected_one[name] = value;
      this.setState({ team_details: new_selected_one });
    }
    console.log(name, value);
    console.log(this.state);
  }

  handleFilelogo(event) {
    var reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    var new_selected_logo = Object.assign({}, this.state.new_logo);
    new_selected_logo = event.target.files[0];
    let file = event.target.files[0];
    reader.onloadend = () => {
      this.setState({ file, new_logo: new_selected_logo, logo_preview: reader.result });
    };
  }

  toAddPlayerView(team) {
    console.log(team.team.id, team.team.name);
    this.setState({ team_name: team.team.name, team_id: team.team.id, addMemberView: !this.state.addMemberView });
  }

  editTeamView(team_id) {
    this.setState({ selected_team_id: team_id, showAllField: !this.state.showAllField });
    if(this.state.showAllField) { this.getTeamList(); }
  }

  handleSubmit(event) {
    if(!this.state.batch_team) {
      var new_selected_one = Object.assign({}, this.state.team_details);
      new_selected_one.team.batch = '';
      this.setState({ team_details: new_selected_one });
    }
    this.postSaveTournamentTeam(this.state.team_details, this.props);
  }

  toAddTeamView() { this.setState({ addNewTeamView: !this.state.addNewTeamView }); }

  handleRequestDelete(member) {
    console.log(member);
    this.state.to_delete_member_list.push(member);
    var new_selected_one = Object.assign({}, this.state.team_details);
    const index = new_selected_one.players.findIndex((info) => info.id == member.id);
    new_selected_one.players.splice(index, 1);
    this.setState({ team_details: new_selected_one });
    console.log(this.state.team_details.players);
  }

  handleBack() { this.props.history.goBack(); }

  renderChip(data) {
    return (
      <Chip key={data.id} onRequestDelete={() => this.handleRequestDelete(data)} style={{ margin: 4 }}>
        {data.name}
      </Chip>
    );
  }

  handleBatchTeamCraetion(event) {
    let checked = event.target.checked;
    if(checked) {
      this.setState({ batch_team: true }, () => {
        if(!this.state.venues.length > 0) this.getVenues();
      });
    }
    else { this.setState({ batch_team: false }); }
  }

  getVenues() {
    var game_type = 'football-academy';
    const url = `${getLocationOrigin()}/venue_list/get_sporthood_locations/?game_type=${game_type}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => {
        this.setState({ venues: data.venues, cities: data.cities }, () => {
          if(this.state.team_details.team.venue) {
            let selected_venue = this.state.venues.filter(info => info.id == this.state.team_details.team.venue);
            if(selected_venue && selected_venue.length > 0) { this.onClickVenue(selected_venue[0]); }
          }
        });
      })
      .catch(error => error);
  }

  handleVenueChange(event) {
    console.log("handleVenueChange");
    var venue_name = event.target.value;
    var filtered_venues = [];
    if(venue_name == '')
      filtered_venues = this.state.venues.slice(0, 10);
    else {
      filtered_venues = this.state.venues.filter(venue => (venue.name.toLowerCase().indexOf(venue_name.toLowerCase()) !== -1));
      if(filtered_venues && filtered_venues.length > 0) filtered_venues = filtered_venues;
      if(filtered_venues.length > 10) filtered_venues = filtered_venues.slice(0, 10);
    }
    this.setState({ selected_venue: venue_name, filtered_venues: filtered_venues });
  }

  onClickVenue(venue) {
    this.setState({ selected_venue: venue.name, selected_venue_id: venue.id, batches: [], filtered_venues: [] }, () => {
      this.getBatches();
    });
  }

  getBatches() {
    var game_type = 'football-academy';
    const url = `${getLocationOrigin()}/eagleeye/get_batches_for_team_creation/?game_type=${game_type}&venue_id=${this.state.selected_venue_id}`;
    const options = {...defaultOptions};
    return fetch(url, options)
      .then(checkStatus).then(parseJSON)
      .then(data => { this.setState({ batches: data.result.fixture_details }); })
      .catch(error => error);
  }

  render() {
    console.log('Teams');
    console.log(this.state);

    const { team_details, batch_team, logo_preview, toast } = this.state;

    return (
      <div style={{ fontFamily: "'DM Sans', 'Segoe UI', sans-serif", background: colors.bg, minHeight: '100vh', padding: '24px 20px', boxSizing: 'border-box' }}>
        <div style={{ maxWidth: 680, margin: '0 auto' }}>
          <div style={{ background: colors.surface, borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08), 0 4px 16px rgba(0,0,0,0.06)', overflow: 'hidden' }}>

            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 24px', borderBottom: `1px solid ${colors.border}` }}>
              <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: colors.text }}>Edit Team</h2>
            </div>

            <div style={{ padding: '20px 24px' }}>
              <Toast message={toast && toast.message} type={toast && toast.type} onClose={() => this.setState({ toast: null })} />

              {/* Batch selection toggle */}
              <div style={{ ...form.row, marginBottom: 20 }}>
                <div style={form.labelWide}>Batch Selection</div>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13, color: colors.text }}>
                  <input
                    type="checkbox"
                    checked={this.state.batch_team}
                    onChange={this.handleBatchTeamCraetion}
                    style={{ width: 16, height: 16, cursor: 'pointer', accentColor: colors.brand }}
                  />
                  <span>Create team from existing batch</span>
                </label>
              </div>

              {/* Name / Squad Name */}
              <div style={form.row}>
                <div style={form.labelWide}>{batch_team ? 'Squad Name' : 'Name'}</div>
                <input
                  type="text"
                  name="name"
                  style={form.input}
                  value={team_details.team.name}
                  onChange={(e) => this.handleChange(e, team_details.id)}
                />
              </div>

              {/* Category — only shown when not batch team */}
              {!batch_team && (
                <div style={form.row}>
                  <div style={form.labelWide}>Category</div>
                  <select
                    name="age_groups"
                    style={form.select}
                    value={team_details.age_groups ? team_details.age_groups.id : ''}
                    onChange={(e) => this.handleChange(e, team_details.id)}
                  >
                    <option value=''>--------</option>
                    {this.state.age_groups.map((x, index) => (
                      <option key={x.id} value={x.id}>{x.name}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Venue — only shown for batch teams */}
              {batch_team && (
                <div style={form.row}>
                  <div style={form.labelWide}>Venue</div>
                  <div style={{ flex: 1, position: 'relative' }}>
                    <input
                      autoComplete="off"
                      type="text"
                      name="venue"
                      style={form.input}
                      value={this.state.selected_venue}
                      onChange={this.handleVenueChange}
                    />
                    {this.state.filtered_venues.length > 0 && (
                      <div style={{
                        position: 'absolute', top: '100%', left: 0, right: 0, zIndex: 100,
                        background: colors.surface, border: `1px solid ${colors.border}`,
                        borderRadius: 8, boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
                        maxHeight: 220, overflowY: 'auto', marginTop: 4,
                      }}>
                        {this.state.filtered_venues.map((venue, index) => (
                          <div
                            key={index}
                            onClick={() => { this.onClickVenue(venue); }}
                            style={{
                              padding: '10px 14px', cursor: 'pointer', fontSize: 13, color: colors.text,
                              borderBottom: `1px solid ${colors.border}`,
                            }}
                            onMouseEnter={e => e.currentTarget.style.background = colors.bg}
                            onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
                          >
                            {venue.name}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              )}

              {/* Batch — only shown for batch teams */}
              {batch_team && (
                <div style={form.row}>
                  <div style={form.labelWide}>Batch</div>
                  <select name="batch" style={form.select} value={team_details.team.batch} onChange={this.handleChange}>
                    <option value=''>------------</option>
                    {this.state.batches.length > 0 && this.state.batches.map((batch, index) => (
                      <option key={index} value={batch.id}>{batch.squad_name ? batch.squad_name : batch.name}</option>
                    ))}
                  </select>
                </div>
              )}

              {/* Group */}
              <div style={form.row}>
                <div style={form.labelWide}>Group</div>
                <input
                  type="text"
                  name="group"
                  style={form.input}
                  value={team_details.group}
                  onChange={(e) => this.handleChange(e, team_details.group)}
                />
              </div>

              {/* No. of Players */}
              <div style={form.row}>
                <div style={form.labelWide}>No. of Players</div>
                <div style={{ flex: 1, fontSize: 13, fontWeight: 600, color: colors.text, paddingTop: 4 }}>
                  {team_details && team_details.no_of_players}
                </div>
              </div>

              {/* Player list with chips */}
              <div style={form.row}>
                <div style={form.labelWide}>Player List</div>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 8 }}>
                    {team_details.players && team_details.players.map(this.renderChip, this)}
                  </div>
                  <button
                    type="button"
                    style={{ ...btn.outlineSm, display: 'flex', alignItems: 'center', gap: 6 }}
                    onClick={() => { this.toAddPlayerView(team_details); }}
                  >
                    <i className="fa fa-user-plus" /> Add Player
                  </button>
                </div>
              </div>

              {/* Logo section — only for TEAM type */}
              {team_details && team_details.team_type == 'TEAM' && (
                <div>
                  <div style={form.row}>
                    <div style={form.labelWide}>Logo</div>
                    <div style={{ flex: 1 }}>
                      <img
                        id="logo"
                        src={
                          logo_preview
                            ? logo_preview
                            : team_details && (team_details.logo && team_details.logo.includes('http')
                              ? team_details.logo
                              : 'https://localhost:8000' + team_details.logo)
                        }
                        alt="LOGO"
                        style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8, border: `1px solid ${colors.border}` }}
                      />
                    </div>
                  </div>
                  <div style={form.row}>
                    <div style={form.labelWide}>{team_details && team_details.logo ? 'Change Logo' : 'Upload Logo'}</div>
                    <div style={{ flex: 1 }}>
                      <input
                        type="file"
                        style={{ ...form.input, padding: '7px 12px' }}
                        name="new_logo"
                        onChange={(e) => this.handleFilelogo(e)}
                      />
                      <div style={{ fontSize: 11, color: colors.muted, marginTop: 4 }}>
                        Only png, jpg, jpeg, gif allowed
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Add member view */}
              {this.state.addMemberView && (
                <div style={{ marginTop: 16, paddingTop: 16, borderTop: `1px solid ${colors.border}` }}>
                  <AddMember team_id={this.state.id} team_name={team_details.team.name} tournament_id={team_details.tournament} />
                </div>
              )}

              {/* Footer */}
              <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', paddingTop: 16, borderTop: `1px solid ${colors.border}`, marginTop: 8 }}>
                <button type="button" style={btn.cancel} onClick={() => this.handleBack()}>Cancel</button>
                <button type="button" style={btn.primary} onClick={this.handleSubmit}>Update</button>
              </div>

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default EditTournamentTeam;


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/editTournamentTeam/index.js